import { Locale } from "@/i18n-config";
import { defineLocaleRecord } from "@/i18n-config";

type AuthSocialCopy = {
  continueWithGoogle: string;
  continueWithGithub: string;
  connecting: string;
};

const authSocialCopyByLocale = defineLocaleRecord<AuthSocialCopy>({
  en: {
    continueWithGoogle: "Continue with Google",
    continueWithGithub: "Continue with GitHub",
    connecting: "Connecting...",
  },
  fr: {
    continueWithGoogle: "Continuer avec Google",
    continueWithGithub: "Continuer avec GitHub",
    connecting: "Connexion...",
  },
  ru: {
    continueWithGoogle: "Продолжить через Google",
    continueWithGithub: "Продолжить через GitHub",
    connecting: "Подключение...",
  },
  uk: {
    continueWithGoogle: "Продовжити через Google",
    continueWithGithub: "Продовжити через GitHub",
    connecting: "Пiдключення...",
  },
  de: {
    continueWithGoogle: "Mit Google fortfahren",
    continueWithGithub: "Mit GitHub fortfahren",
    connecting: "Verbindung...",
  },
  es: {
    continueWithGoogle: "Continuar con Google",
    continueWithGithub: "Continuar con GitHub",
    connecting: "Conectando...",
  },
  it: {
    continueWithGoogle: "Continua con Google",
    continueWithGithub: "Continua con GitHub",
    connecting: "Connessione...",
  },
  pt: {
    continueWithGoogle: "Continuar com o Google",
    continueWithGithub: "Continuar com o GitHub",
    connecting: "Conectando...",
  },
});

export function getAuthSocialCopy(lang: Locale): AuthSocialCopy {
  return authSocialCopyByLocale[lang];
}
